import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomURLEncoder } from '../utils/custom-url-encoder';

@Injectable()
export class ParamsEncodingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newParams = new HttpParams({
      encoder: new CustomURLEncoder(),
      fromString: req.params.toString(),
    });
    const changedReq = req.clone({ params: newParams });
    return next.handle(changedReq);
  }
}
